import { useGetDocumentOrderFilterDimensions } from "hooks/api/documents/documentFilterDimensions";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { removeNullable } from "services/apiHelpers";
import {
  CheckboxListFilter,
  FilterOption,
} from "../GenericFilters/CheckboxListFilter";
import { FilterProps } from "../filter-definition";

export const OrdersShipFromFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();

  const { data, isLoading } = useGetDocumentOrderFilterDimensions(cardCodes);

  const shipFromOptions: FilterOption[] = removeNullable(
    data?.shipFromWarehouses?.map((shipFrom) => ({
      label: shipFrom.Name,
      value: shipFrom.Code,
    })) ?? []
  );

  return (
    <CheckboxListFilter
      filterKey="shipFrom"
      name="Ship From"
      variant={variant}
      filterOptions={shipFromOptions}
      isLoading={isLoading}
    />
  );
};
